import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';

import { AuthHttpService } from '@ib-core/services/auth-http.service';
import { FORM_ERRORS } from '@ib-enums/form-control-errors.enum';
import { BehaviorSubject, map, Observable, of } from 'rxjs';

export class EmailAvailabilityAsyncValidator {
  static createValidator(
    authHttp: AuthHttpService,
    error: FORM_ERRORS,
    loading$: BehaviorSubject<boolean>,
  ): AsyncValidatorFn {
    const checkedAvailableEmails: Record<string, boolean> = {};
    return (control: AbstractControl): Observable<ValidationErrors> => {
      const keys = Object.keys(control.errors || {});
      const isValid =
        keys.length === 0 || (keys.length === 1 && keys[0] === error);
      if (isValid) {
        const email = control.value;
        if (email) {
          if (typeof checkedAvailableEmails[control.value] === 'boolean') {
            const isAvailable = checkedAvailableEmails[email];
            return of(isAvailable ? null : { [error]: true });
          } else {
            loading$.next(true);
            return authHttp.checkIsEmailAvailable(email).pipe(
              map(res => {
                loading$.next(false);
                checkedAvailableEmails[email] = res.available;
                const err = res.available ? null : { [error]: true };
                if (err) {
                  control.markAsTouched();
                  control.markAsDirty();
                }
                return err;
              }),
            );
          }
        } else {
          return of(null);
        }
      } else {
        return of(null);
      }
    };
  }
}
